import { Close } from "@mui/icons-material";
import { IconButton, Snackbar } from "@mui/material";
import { atom, useAtomValue, useSetAtom } from "jotai";
import React from "react";

const communicationsMessageListAtom = atom([] as string[]);
const pendingCommunicationsAtom = atom<string | null>((get) => {
  const allMessages = get(communicationsMessageListAtom);
  if (!allMessages || allMessages.length <= 0) {
    return null;
  }
  return allMessages[allMessages.length - 1];
});
export const clearMessageAtom = atom(null, (get, set) => {
  const allMessages = get(communicationsMessageListAtom);
  const newMessages = allMessages.slice(0, -2);
  set(communicationsMessageListAtom, newMessages);
});

export const addMessageAtom = atom(null, (get, set, msg) => {
  const allMessages = get(communicationsMessageListAtom);
  const newMessages = [...allMessages, String(msg)];
  set(communicationsMessageListAtom, newMessages);
});

export function UserCommunicationsToast() {
  const message = useAtomValue(pendingCommunicationsAtom);
  const clearMessage = useSetAtom(clearMessageAtom);
  const addMessage = useSetAtom(addMessageAtom);
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={clearMessage}
      >
        <Close fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  return (
    <>
      <Snackbar
        open={!!message}
        autoHideDuration={6000}
        message={message}
        onClose={clearMessage}
        action={action}
      />
    </>
  );
}
